<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Пополнить счет</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="nav nav-pills my-1">
          <li class="nav-item">
            <a :class="'btn btn-outline-primary nav-link ' + (this.fiz ? '' : 'active')" @click="changeFiz(false)">Юр. лицо</a>
          </li>
          <li class="nav-item">
            <a :class="'btn btn-outline-primary nav-link ' + (this.fiz ? 'active' : '')" @click="changeFiz(true)">Физ. лицо</a>
          </li>
        </ul>
        <div class="form-group mt-2">
          <label>Сумма <strong style="color: red;">(минимальная сумма {{ minValue }} руб.)</strong></label>
          <div class="input-group">
            <input v-model="value" type="number" class="form-control" :min="minValue">
            <div class="input-group-append">
              <span class="input-group-text">руб.</span>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="fiz">
          <label>Способ оплаты</label>
          <v-multiselect
            :options="options"
            v-model="method"
            label="label"
            trackBy="value"
            :allow-empty="false"/>
        </div>
      </div>
      <div class="modal-footer">
        <btn-action class="btn btn-primary" :disabled="!value" @click="refill">Пополнить</btn-action>
        <button class="btn btn-outline-light" @click="$emit('hide')">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    data () {
      return {
        fiz: false,
        value: this.minValue,
        method: {
          value: 'b2b_sberbank',
        },
        options: [
          {
            value: 'sbp',
            label: 'СБП (Система быстрых платежей)',
          },
          {
            value: 'bank_card',
            label: 'Банковская карта',
          },
          {
            value: 'yoo_money',
            label: 'ЮMoney',
          },
          {
            value: 'alfabank',
            label: 'Альфа-Клик',
          },
          {
            value: 'sberbank',
            label: 'Сбербанк Онлайн',
          },
          {
            value: 'tinkoff_bank',
            label: 'Тинькофф',
          },
        ],
      }
    },
    computed: {
      minValue () {
        const lowLimitUsers = [
          'e0630ccc-01a4-4b02-9261-e57a6daf1822',
          '05d9f056-c9aa-474c-91f7-40a9700f118b',
        ]

        const currentUserId = this.$root && this.$root.user && this.$root.user.id

        return currentUserId && lowLimitUsers.includes(currentUserId)
          ? 1
          : 100
      },
    },
    methods: {
      refill () {
        if (this.value >= this.minValue)
          api.post('payments', {
            value: this.value,
            method: this.method.value,
          })
            .then(({data}) => {
              window.location = data.url
            })
      },
      changeFiz (value) {
        this.fiz = value
        if (value) {
          this.method =  {
            value: 'sbp',
            label: 'СБП (Система быстрых платежей)',
          }
        } else {
          this.method.value = 'b2b_sberbank'
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/payments/refill-modal.vue